/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAirport } from './PaxCheckAirport';
import {
    PaxCheckAirportFromJSON,
    PaxCheckAirportFromJSONTyped,
    PaxCheckAirportToJSON,
    PaxCheckAirportToJSONTyped,
} from './PaxCheckAirport';

/**
 * Departure point - API output
 * @export
 * @interface PaxCheckDeparturePoint
 */
export interface PaxCheckDeparturePoint {
    /**
     * 
     * @type {PaxCheckAirport}
     * @memberof PaxCheckDeparturePoint
     */
    airport: PaxCheckAirport;
    /**
     * Date and time of departure (local)
     * @type {string}
     * @memberof PaxCheckDeparturePoint
     */
    departureDatetime: string;
    /**
     * ISO 3166-1 alpha-3 country code
     * @type {string}
     * @memberof PaxCheckDeparturePoint
     */
    countryCode: string;
}

/**
 * Check if a given object implements the PaxCheckDeparturePoint interface.
 */
export function instanceOfPaxCheckDeparturePoint(value: object): value is PaxCheckDeparturePoint {
    if (!('airport' in value) || value['airport'] === undefined) return false;
    if (!('departureDatetime' in value) || value['departureDatetime'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function PaxCheckDeparturePointFromJSON(json: any): PaxCheckDeparturePoint {
    return PaxCheckDeparturePointFromJSONTyped(json, false);
}

export function PaxCheckDeparturePointFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDeparturePoint {
    if (json == null) {
        return json;
    }
    return {
        
        'airport': PaxCheckAirportFromJSON(json['airport']),
        'departureDatetime': json['departure_datetime'],
        'countryCode': json['country_code'],
    };
}

export function PaxCheckDeparturePointToJSON(json: any): PaxCheckDeparturePoint {
    return PaxCheckDeparturePointToJSONTyped(json, false);
}

export function PaxCheckDeparturePointToJSONTyped(value?: PaxCheckDeparturePoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airport': PaxCheckAirportToJSON(value['airport']),
        'departure_datetime': value['departureDatetime'],
        'country_code': value['countryCode'],
    };
}

